import { _, bb } from "$json";
import { fromApiServer } from "$json/lib/location";
/* savecase-native-dialog:
 *
 * Download and upload cases
 *
 * Author: Niels Giesen
 * Copyright 2018 Berkeley Bridge
 *
 */
(function ($, document) {
  $(function () {
    var $doc = $(document),
      $formDialog = $(
        `<dialog id="bb-p-loadcaseform">
          <form
            target="_self"
            action="${fromApiServer("loadcase?fmt=json")}"
            accept="text/plain"
            enctype="multipart/form-data"
            method="post"
          >
          <button type="reset"><span aria-hidden>×</span><span class="a-offscreen">${_("cancel")}</span></button>
            <div>
              <input type="hidden" name="uniqueid" />
              <input type="hidden" name="dbname" />
              <input type="hidden" name="sessionid" />
              <input
                type="file"
                name="case"
                required="required"
                id="bb-loadcasefile"
                accept=".cas"
              />
              <p>${_("Choose the session file you saved earlier")}</p>
              <input name="add" type="submit" class="submit" value="${_(
                "load"
              )}"
              /> <input name="cancel" type="reset" value="${_("cancel")}" />
            </div>
          </form>
        </dialog>`
      );

    let focus;
    var dialog = $formDialog.get(0);
    var $form = $formDialog.find("form"); // Reference the <form> element

    // Memorize state vars
    var uid, sid, db;

    // The form dialog is appended to the body
    $formDialog.appendTo("body");

    dialog.addEventListener("close", function () {
      // Original close handler logic
    });

    // --- Fetch Submission Logic ---
    $form.on("submit", async function (event) {
      event.preventDefault(); // *** CRITICAL: Stop the default form submission ***

      dialog.close();
      $(".progress").fadeIn();
      bb.Mode.set("busy");

      // Get the form data (including the file)
      const formData = new FormData(this);

      // Update hidden fields with current variables before submission
      $form.find("input[type=hidden]").each(function () {
        const name = $(this).attr("name");
        // Assuming bb.getVar is a valid function to retrieve global state
        const val = bb.getVar(name);
        if (val) {
          formData.set(name, val);
        }
      });

      const url = this.action;

      try {
        // Use fetch() to submit the FormData
        const response = await fetch(url, {
          method: "POST",
          body: formData
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Read the response as JSON
        const data = await response.json();

        // Trigger the original event sequence
        $doc
          .trigger("bb:preHandleData", data)
          .trigger("bb:handleData", data)
          .trigger("bb:postHandleData", data);
      } catch (e) {
        console.error("Case loading failed:", e);
        // Add user-facing error handling here if necessary
      } finally {
        $(".progress").fadeOut();
        bb.Mode.set("idle");
      }
    });
    // --- End Fetch Submission Logic ---

    // Original handlers for file change and reset
    $form
      .find("[type=file]")
      .on("change", function () {
        $formDialog.find("input[type=submit]").trigger("focus");
      })
      .end()
      .find("[type=reset]")
      .on("click", function () {
        dialog.close();
      });

    dialog.addEventListener("close", () => {
      focus && focus.focus();
    });

    // Listen on the 'load button' that may be anywhere on the page
    $("[data-rel=load]")
      .on("keydown", function (ev) {
        if (ev.keyCode === 13) {
          // Dispatch to click handler on ENTER.
          $(this).trigger("click");
          return false;
        }
        return true;
      })
      .on("click", function () {
        focus = this;
        dialog.showModal();
        const file = dialog.querySelector(`input[type="file"]`);
        file && file.focus();
      });

    // Original handler for postHandleData
    $doc.on("bb:postHandleData", function (event, data) {
      if (data && data.uniqueid && data.sessionid && data.dbname) {
        if (
          uid !== data.uniqueid ||
          sid !== data.sessionid ||
          db !== data.dbname
        ) {
          uid = data.uniqueid;
          sid = data.sessionid;
          db = data.dbname;
          $("a[data-rel=save]").attr({
            href: fromApiServer(
              "savecase?" +
                $.param({
                  uniqueid: data.uniqueid,
                  sessionid: data.sessionid,
                  dbname: data.dbname
                })
            ),
            download:
              data.modelname +
              "." +
              data.sessionid +
              $.datepicker.formatDate("yymmdd", new Date()) +
              ".cas"
          });

          // This block should update hidden fields based on *new* data, if necessary.
          // It's separate from the submission update.
          $formDialog.find("input[type=hidden]").each(function () {
            var val = bb.getVar($(this).attr("name"));
            if (val) $(this).val(val);
          });
        }
      }
    });
  });
})(jQuery, document);
